<template>
    <div id="cb-training">
        <div style="background-color: #ffffff" class="d-flex">
            <div class="side-menubar-wrapper">
                <SideMenuBar />
            </div>
            <div class="content">
                <div class="filters">
                    <MiniFilterPreview
                        type="period"
                        v-model="filters.period"
                        v-if="!!filters.period"
                        :on-removed="() => (filters.period = undefined)"
                        :label="getFilterLabel('period')"
                    />
                    <MiniFilterPreview
                        type="story"
                        v-model="filters.storyId"
                        v-if="!!filters.storyId"
                        :on-removed="() => (filters.storyId = undefined)"
                        :label="getFilterLabel('story')"
                    />
                    <MiniFilterPreview
                        type="ignore"
                        v-model="filters.ignored"
                        v-if="!!filters.ignored"
                        :on-removed="() => (filters.ignored = undefined)"
                        :label="getFilterLabel('ignore')"
                    />
                    <MiniFilterPreview
                        type="query"
                        v-model="filters.query"
                        v-if="!!filters.query"
                        :on-removed="() => (filters.query = undefined)"
                        :label="getFilterLabel('query')"
                    />
                </div>

                <div class="wrapper">
                    <div class="cb-train-query-list-pagination">
                        <Pagination
                            :page-change="pageChange"
                            :page-sizes="pagination.pageSizes"
                            :total="total"
                            pageSizeLocalStorageKey="cb-train-page-size"
                        />
                    </div>
                    <QueryList
                        :selected-items="selectedItems"
                        :on-select-changed="onSelectChanged"
                        :rows="rows"
                        :select-all="selectAll"
                        :unselect-all="unselectAll"
                        :delete-single-row="deleteSingleRow"
                        :ignore-single-row="ignoreSingleRow"
                        :train-single-row="trainSingleRow"
                        :delete-multi-row="deleteMultiRow"
                        :ignore-multi-row="ignoreMultiRow"
                        :train-multi-row="trainMultiRow"
                        :stories="stories"
                        class="cb-trian-query-list"
                        @isAnyTrained="isAnyTrained = true"
                    />
                    <div class="cb-train-query-list-pagination">
                        <Pagination
                            :page-change="pageChange"
                            :page-sizes="pagination.pageSizes"
                            :total="total"
                            pageSizeLocalStorageKey="cb-train-page-size"
                        />
                    </div>
                </div>
            </div>
            <div class="side-filter-wrapper">
                <TrainingFilterTool :stories="stories" v-model="filters" :row-count="rows.length" />
            </div>
        </div>
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar";
import { mapActions, mapMutations, mapGetters } from "vuex";
import QueryList from "./QueryList";
import { CHATBOT_API } from "../../../../../api/chatbotv2";
import log2 from "../../../../../utils/log2";
import TrainingFilterTool from "./TrainingFilterTool";
import _ from "lodash";
import MiniFilterPreview from "./MiniFilterPreview";
import Pagination from "../../../../../components/Pagination";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import { Modal } from "ant-design-vue";

const log = log2("Training");
export default {
    name: "Training",
    components: { SideMenuBar, QueryList, TrainingFilterTool, MiniFilterPreview, Pagination },
    data() {
        return {
            isAnyTrained: false,
            loading: false,
            selectedItems: [],
            rows: [],
            stories: [],
            total: 0,
            pagination: {
                perPage: 10,
                page: 1,
                pageSizes: ["100", "250", "500", "1000"],
            },
            filters: {
                period: undefined,
                ignored: undefined,
                storyId: undefined,
                query: undefined,
            },
            destroyText: this.$t("chatbotv2.trainingAlert"),
            destroyTitle: this.$t("message.importantWarning"),
            destroyButtonOkText: this.$t("message.ok"),
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            updateStory: "CB/updateStory",
        }),
        ...mapMutations({
            SET_LARGE_HEADER: "app/SET_LARGE_HEADER",
        }),
        info() {
            const h = this.$createElement;
            this.$info({
                title: this.destroyTitle,
                content: h("div", {}, [h("h6", this.destroyText)]),
                okText: this.destroyButtonOkText,
                width: 550,
            });
        },

        pageChange(page, pageSize) {
            log("pageChange", { page, pageSize });
            this.pagination.page = page;
            this.pagination.perPage = pageSize;
        },
        fetch() {
            if (this.rows.length > this.total) return;
            CHATBOT_API.TRAINING.list({ ...this.filters, ...this.pagination })
                .then((res) => {
                    const { items, total, page } = res.data;
                    this.rows = items;
                    this.total = total;
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        fetchStories() {
            CHATBOT_API.listStories()
                .then((res) => {
                    this.stories = res.data;
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        onSelectChanged(id) {
            if (this.selectedItems.includes(id)) {
                this.selectedItems = this.selectedItems.filter((item) => item !== id);
            } else {
                this.selectedItems.push(id);
            }
        },
        selectAll() {
            this.selectedItems = this.rows.map((row) => row._id);
        },
        unselectAll() {
            this.selectedItems = [];
        },
        deleteSingleRow(id) {
            CHATBOT_API.TRAINING.deleteById(id)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.$message.success({
                            content: `User query deleted`,
                            duration: 2,
                        });
                        this.rows = this.rows.filter((row) => row._id !== id);
                    } else {
                        this.$message.error({
                            content: `User query delete failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        ignoreSingleRow(id) {
            CHATBOT_API.TRAINING.ignoreById(id)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.$message.success({
                            content: `User query ignored`,
                            duration: 2,
                        });
                        this.rows = this.rows.map((row) => {
                            if (row._id === id) {
                                row.ignored = true;
                            }
                            return row;
                        });
                    } else {
                        this.$message.error({
                            content: `User query ignore failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        trainSingleRow(id, storyId, storyVersion, blockId) {
            log("trainSingleRow", { id, storyId, storyVersion, blockId });
            CHATBOT_API.TRAINING.train(id, storyId, storyVersion, blockId)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.rows = this.rows.filter((row) => row._id !== id);
                        this.$message.success({
                            content: `Training success`,
                            duration: 2,
                        });
                        this.updateStory({ id: storyId, version: storyVersion });
                    } else {
                        this.$message.error({
                            content: `Training failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        deleteMultiRow() {
            const ids = this.selectedItems;
            CHATBOT_API.TRAINING.multiDelete(ids)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.$message.success({
                            content: `User queries deleted`,
                            duration: 2,
                        });
                        this.rows = this.rows.filter((row) => !ids.includes(row._id));
                        this.selectedItems = [];
                    } else {
                        this.$message.error({
                            content: `User queries delete failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        ignoreMultiRow() {
            const ids = this.selectedItems;
            CHATBOT_API.TRAINING.multiIgnore(ids)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.$message.success({
                            content: `User queries ignored`,
                            duration: 2,
                        });
                        this.rows = this.rows.map((row) => {
                            if (ids.includes(row._id)) {
                                row.ignored = true;
                            }
                            return row;
                        });
                        this.selectedItems = [];
                    } else {
                        this.$message.error({
                            content: `User queries ignore failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        trainMultiRow(storyId, storyVersion, blockId) {
            const ids = this.selectedItems;
            log("trainSingleRow", { ids, storyId, storyVersion, blockId });
            CHATBOT_API.TRAINING.multiTrain(ids, storyId, storyVersion, blockId)
                .then((res) => {
                    const isSuccess = res.data;
                    if (isSuccess) {
                        this.rows = this.rows.filter((row) => !ids.includes(row._id));
                        this.$message.success({
                            content: `Training success`,
                            duration: 2,
                        });
                        this.selectedItems = [];
                        this.updateStory({ id: storyId, version: storyVersion });
                    } else {
                        this.$message.error({
                            content: `Training failed`,
                            duration: 2,
                        });
                    }
                })
                .catch((err) => {
                    log.error(err);
                });
        },
        getFilterLabel(type) {
            if (type === "story") {
                const story = this.stories.find((story) => story._id === this.filters.storyId);
                log("getFilterLabel", { story });
                return `Story is ${story.title}`;
            } else if (type === "period") {
                const periods = [
                    { value: "today", label: "Today" },
                    { value: "yesterday", label: "Yesterday" },
                    { value: "last7", label: "Last 7 Days" },
                    { value: "last30", label: "Last 30 Days" },
                    { value: "this-month", label: "This Month" },
                    { value: "last-month", label: "Last Month" },
                    { value: "last-3-month", label: "Last 3 Month" },
                    { value: "this-year", label: "This Year" },
                    { value: "last-year", label: "Last Year" },
                ];
                const period = periods.find((period) => period.value === this.filters.period).label;
                return period;
            } else if (type === "query") {
                return `Query = ${this.filters.query}`;
            } else if (type === "ignore") {
                return `Ignored`;
            }
        },
    },
    mounted() {
        this.SET_LARGE_HEADER(false);
        this.fetch();
        this.fetchStories();
        this.loading = false;
    },
    beforeDestroy() {
        this.SET_LARGE_HEADER(true);
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.training.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isAnyTrained) {
            next(false);
            this.info();
            this.isAnyTrained = false;
        } else {
            next();
        }
    },
    watch: {
        filters: {
            handler(filters) {
                log("filters changed", filters);
                this.fetch();
            },
            deep: true,
        },
        pagination: {
            handler() {
                log("pagination changed", this.pagination);
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}

#cb-training {
    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
    }

    .side-filter-wrapper {
        min-height: 100vh;
        flex: 0 0 20%;
    }

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .wrapper {
        height: 100%;

        .cb-trian-query-list {
            height: 80%;
        }

        .cb-train-query-list-pagination {
            height: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: end;
        }
    }

    .content {
        width: 100%;
        padding: 5px;
        min-height: 100vh;
        position: relative;
        background: white;
        box-shadow: 0 0 0 1px rgb(0 0 0 / 5%), 0 4px 24px 2px rgb(0 0 0 / 20%);

        .filters {
            display: flex;
            gap: 10px;
            flex-wrap: wrap;
            padding: 0 43px;
            margin-bottom: 5px;

            .filter-wrapper-preview {
                align-items: center;
                background: #2c3f84;
                border-radius: 4px;
                color: #fff;
                cursor: pointer;
                display: flex;
                font-size: 16px;
                height: 32px;
                padding: 10px;
                transition: all 0.3s;
                white-space: nowrap;
                width: max-content;

                [text-truncate] {
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                [text-actions] {
                    cursor: pointer;
                    -webkit-transition: all 0.3s;
                    transition: all 0.3s;
                }

                &:hover {
                    opacity: 0.8 !important;

                    .material-icons {
                        &.mainIcon {
                            display: none;
                        }

                        &.closeIcon {
                            display: inherit;
                        }
                    }
                }

                .material-icons {
                    font-size: 15px;
                    margin-right: 10px;

                    &.mainIcon {
                        display: inherit;
                    }

                    &.closeIcon {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
